export const environment = {
  production: true,
  apiBaseUrl: 'https://evp-sing-hse.agoraiot.app',
  isAutomationTesting: false,
  appConfigApiUrl: '',
  identityProviderUrl: 'https://csi.slb.com/v2',
  identityProviderClientKey: '2c995a297ec1319499c66f15750095c6',
  identityProviderClientSecret: '2d00e8489f7f45b2a31e3998e9daf1e2acd8399ca4b2a01',
  identityProviderRedirectUrl: 'https://evp-sing-hse.agoraiot.app/login/logincallback',
  authType: '',
};
